import React from 'react';
import { getIntent } from '../../../design-system/intents';

/**
 * FeatureList — title + grid of feature cards. Each item can carry `intent`
 * (capture | focus | plan | commit | private | reflect | delegate | automate | system)
 * which tints the icon dot via design-system intents.
 *
 * data: { title?, items: [{ title, body, intent? }] }
 */
export default function FeatureList({ data = {} }) {
  const { title, items = [] } = data;
  if (items.length === 0) return null;
  return (
    <section data-testid="site-block-feature-list">
      <div className="max-w-6xl mx-auto px-6 py-10">
        {title && (
          <h3 className="text-xl lg:text-2xl font-semibold orka-text-primary mb-8" data-testid="site-block-feature-list-title">
            {title}
          </h3>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it, i) => {
            const intent = it.intent ? getIntent(it.intent) : null;
            const dotColor = intent?.color || 'var(--orka-text-secondary, #475569)';
            return (
              <div
                key={i}
                className="orka-surface-base orka-border-subtle border rounded-2xl p-5 orka-transition-colors hover:orka-surface-raised"
                data-testid={`site-block-feature-${i}`}
              >
                <div className="flex items-start gap-3">
                  <span
                    className="mt-1.5 inline-block w-2 h-2 rounded-full shrink-0"
                    style={{ backgroundColor: dotColor }}
                    aria-hidden="true"
                  />
                  <div>
                    <div className="font-semibold orka-text-primary text-base">{it.title}</div>
                    {it.body && (
                      <p className="mt-1.5 text-sm orka-text-secondary leading-relaxed">{it.body}</p>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
